import React, { useEffect, useRef, useState, useCallback } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { getCookieNoCrypto, setCookieNoCrypto } from "../Utils/CookieHelper";
import { msClientId } from "../Login/authProvider";
import { encryptJWT, jwtEncryptKey } from "../App";
import { Box, Button, CircularProgress, LinearProgress, Typography } from "@mui/material";
import { blobDomain, blobSAS, blobWriteString } from "../Helper/BlobHelper";

// const user = JSON.parse(getCookie("bb_metaverse_user"));
// var access = JSON.parse(getCookie("bb_metaverse_access"));
var CryptoJS = require("crypto-js");
var key = CryptoJS.enc.Utf8.parse('1234567890123456');

function WEBGLPlayer(props) {
    const canvasRef = useRef(null)
    const [devicePixelRatio, setDevicePixelRatio] = useState(window.devicePixelRatio)
    const { unityProvider, requestFullscreen, loadingProgression, isLoaded, unload, addEventListener, sendMessage, removeEventListener } = useUnityContext(props.url);
    const [tempCokkie, setTempCokkie] = useState(true);

    useEffect(() => {
        // Promise.all([blobSAS({token_type: 'read_only', container_name: 'project-executables' }), blobWriteString({ token_type: 'write_only', container_name: 'project-executables' })])
        //eslint-disable-next-line react-hooks/exhaustive-deps
        const updateDevicePixelRatio = function () {
            setDevicePixelRatio(window.devicePixelRatio);
        }

        console.log("[LOG] useEffect (devicePixelRatio) - isLoaded:", isLoaded, "at", new Date().toLocaleTimeString());
        console.log("[LOG] Registering InitiateTakeOff event handler at", new Date().toLocaleTimeString());

        const mediaMatcher = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
        mediaMatcher.addEventListener('change', updateDevicePixelRatio);

        return () => {
            mediaMatcher.removeEventListener('change', updateDevicePixelRatio);
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [devicePixelRatio])

    const sendMessageToUnity = useCallback(() => {
        console.log("[LOG] sendMessageToUnity triggered at", new Date().toLocaleTimeString());
        console.log("[LOG] isLoaded in sendMessageToUnity:", isLoaded);
        if (isLoaded) {
            setTimeout(() => {
                if (sendMessage) {
                    let token = localStorage.getItem("msal."+ msClientId +".idtoken")
                    console.log("[LOG] sendMessage args: InitialCheckList, TakingOff, Dummy at", new Date().toLocaleTimeString());
                    (async () => {
                        let writeSas = await blobWriteString({ token_type: 'write_only', container_name: 'project-executables' });
                        let readSas = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' });
                        let data = {
                            token: encryptJWT("D1R1P" + token + "D1R1P", key),
                            domain: localStorage.getItem("api_domain") ? localStorage.getItem("api_domain") : null,
                            blobDomain: blobDomain(),
                            blobSAS: readSas,
                            blobWriteString: writeSas,
                            assetData: props.assetData,
                        }
                        const jsonData = JSON.stringify(data);
                        sendMessage("InitialCheckList", 'TakingOff', jsonData);
                    })();
                }
            }, 1000);
        } else {
            console.log("[LOG] Unity not loaded, sendMessage not called at", new Date().toLocaleTimeString());
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded, sendMessage]);

    useEffect(() => {

        let mounted = true;

        const attemptSend = (tries = 0) => {
            if (!mounted) return;
            console.log(`[LOG] attemptSend try=${tries} isLoaded=${isLoaded} sendMessageType=${typeof sendMessage}`);
            if (typeof sendMessage === 'function') {
                try {
                    sendMessageToUnity()
                } catch (err) {
                    console.log("[LOG] sendMessage threw, will retry:", err);
                    if (tries < 10) setTimeout(() => attemptSend(tries + 1), 500);
                }
            } else {
                if (tries < 10) setTimeout(() => attemptSend(tries + 1), 500);
                else console.log('[LOG] sendMessage not available after retries');
            }
        }

        if (isLoaded) {
            console.log("[LOG] Unity is loaded, registering event and scheduling send at", new Date().toLocaleTimeString());
            addEventListener("InitiateTakeOff", sendMessageToUnity);
            // try once after a short delay and then retry inside attemptSend if needed
            setTimeout(() => attemptSend(0), 500);
        }

        return () => {
            mounted = false;
            if (typeof removeEventListener === 'function') {
                try {
                    removeEventListener("InitiateTakeOff", sendMessageToUnity);
                    console.log('[LOG] removeEventListener called for InitiateTakeOff');
                } catch (err) {
                    console.log('[LOG] removeEventListener threw:', err);
                }
            }
        }
    }, [isLoaded, sendMessage, addEventListener, removeEventListener, sendMessageToUnity])



    async function unLoadApp() {
        if (isLoaded) {
            await unload()
        }
        props.close()
    }

    if (isLoaded && tempCokkie && props.assetData.asset_key !== "cloud_gl") {
        setTempCokkie(false)

        // console.log("msal." + msClientId + ".idtoken")

        // console.log(getCookieNoCrypto("msal." + msClientId + ".idtoken"))

        // console.log(jwtEncryptKey())

        // console.log(encryptJWT("D1R1P" + getCookieNoCrypto("msal." + msClientId + ".idtoken") + "D1R1P", jwtEncryptKey()))

        setCookieNoCrypto('bb_metaverse_msal_tempdr', encryptJWT("D1R1P" + getCookieNoCrypto("msal." + msClientId + ".idtoken") + "D1R1P", jwtEncryptKey()), { secure: true, 'max-age': 25, 'domain': window.location.host, 'samesite': 'None', 'path': '/', },);
        // setCookieNoCrypto('bb_metaverse_token_tempdr', token, { secure: true, 'max-age': 10, 'domain': window.location.host, 'samesite': 'None', 'path': '/', },);
        // setCookieNoCrypto('bb_metaverse_user_tempdr', JSON.stringify(user), { secure: true, 'max-age': 10, 'domain': window.location.host, 'samesite': 'None', 'path': '/', },);
        // setCookieNoCrypto('bb_metaverse_access_tempdr', JSON.stringify(access), { secure: true, 'max-age': 10, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
        if (props.assetData) {
            setCookieNoCrypto('bb_metaverse_version_tempdr', JSON.stringify(props.assetData), { secure: true, 'max-age': 25, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
        }
    }

    return <div>

        {!isLoaded && (
            <Box display='flex' flexDirection={'column'} alignItems={'center'}>
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Box marginRight={1}><CircularProgress size={15} /></Box>
                    <p>Loading Application...</p>
                </Box>
                <Box display="flex" alignItems="center" flexDirection={'row'} width="100%">
                    <Box width="100%" mr={1}>
                        <LinearProgress variant="determinate" value={Math.round(loadingProgression * 100)} />
                    </Box>
                    <Box minWidth={35}>
                        <Typography variant="body2" color="primary">{`${Math.round(loadingProgression * 100,)}%`}</Typography>
                    </Box>
                </Box>
            </Box>
        )}

        <Box display='flex' flexDirection={'row'} width='100%'>
            <Box width='100%' flexGrow={1}>
                <Unity unityProvider={unityProvider}
                    ref={canvasRef}
                    style={{ height: window.innerHeight * (isLoaded ? .75 : 0), width: window.innerWidth * .75 }}
                    tabIndex={1}
                    devicePixelRatio={devicePixelRatio}
                />
            </Box>

        </Box>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
            {isLoaded ? <div>
                <Button size="small" variant="contained" color="primary" onClick={() => requestFullscreen(true)}>Fullscreen</Button>
            </div> : null}
            <Box marginLeft="5px">
                <Button size="small" variant="contained" color="primary" onClick={() => { unLoadApp() }}>{isLoaded ? "Exit" : "Cancel Download"}</Button>
            </Box>
        </Box>
    </div>



}

export default WEBGLPlayer